import { useIntl as platformIntl } from "@platform/cj-platform-navigation";
import { useIntl as reactIntl } from "react-intl";
import { useNewNavigation } from "./useNewNavigation";

export const useIntl = () => {
  const { use2022Nav } = useNewNavigation();
  return use2022Nav ? platformIntl() : reactIntl();
};
